import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'ti-info-block',
  templateUrl: './info-block.component.html',
  styleUrls: ['./info-block.component.sass'],
})
export class InfoBlockComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
